var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('main',[_c('h2',{staticClass:"text-center my-4 display-4"},[_vm._v("Om oss")]),_c('block-content',{attrs:{"blocks":_vm.blocks}}),_c('partners'),_c('contact-form')],1)}
var staticRenderFns = []

export { render, staticRenderFns }